( function( $ ) {
  'use strict';

  $( function() {
    const $calendar = $( '[id^="mec_full_calendar_container_"]' ).first();
    const $search = $( '[id^="mec_sf_s_"]' ).first();

    if ( !$calendar.length || !$search.length || typeof llEventsSearch === 'undefined' ) {
      return;
    }

    const $form = $search.closest( 'form' );
    const $status = $form.find( '[role="status"]' );
    const $results = $( '<div class="ll-event-search-results" hidden></div>' );
    let request = null;
    let timer = null;

    $calendar.before( $results );
    $search.attr( {
      'placeholder': 'Search all events',
      'title': 'Search all events',
      'aria-label': 'Search all events',
      'aria-controls': 'll-event-search-results',
    } );
    $results.attr( 'id', 'll-event-search-results' );

    const $searchWrap = $search.closest( '.mec-text-input-search' );
    const $dateWrap = $form.find( '.mec-date-search' );
    const $monthSelect = $dateWrap.find( '[id^="mec_sf_month_"]' );
    const $yearSelect = $dateWrap.find( '[id^="mec_sf_year_"]' );

    $searchWrap.prepend(
        $( '<label class="ll-event-control-label"></label>' )
            .attr( 'for', $search.attr( 'id' ) )
            .text( 'Search all events' ),
    );
    $dateWrap.prepend(
        $( '<label class="ll-event-control-label"></label>' )
            .attr( 'for', $monthSelect.attr( 'id' ) )
            .text( 'Jump to a month' ),
    );
    const $searchIcon = $searchWrap.children( 'i' ).first();
    const $searchInputWrap = $( '<div class="ll-event-search-input"></div>' );
    $searchIcon.add( $search ).wrapAll( $searchInputWrap );
    $dateWrap.before( '<span class="ll-event-search-or" aria-hidden="true">or</span>' );
    $monthSelect.attr( 'aria-label', 'Month to view' );
    $yearSelect.attr( 'aria-label', 'Year to view' );

    // MEC attaches its month-limited keyword search to this change event.
    // Remove only that listener; the month and year filters still use MEC.
    window.setTimeout( function() {
      $search.off( 'change' );
    }, 0 );

    $form.on( 'submit.llEventsSearch', function( event ) {
      event.preventDefault();
    } );

    $search.on( 'input.llEventsSearch', function() {
      window.clearTimeout( timer );
      timer = window.setTimeout( runSearch, 300 );
    } );

    function runSearch() {
      const term = $.trim( $search.val() );

      if ( request ) {
        request.abort();
      }

      if ( term.length < 2 ) {
        showCalendar();
        return;
      }

      $calendar.attr( 'hidden', true );
      $results.removeAttr( 'hidden' ).empty().append(
          $( '<p class="ll-event-search-message"></p>' ).text( 'Searching all events…' ),
      );
      $status.text( 'Searching all events' );

      request = $.getJSON( llEventsSearch.ajaxUrl, {
        action: 'll_search_all_events',
        nonce: llEventsSearch.nonce,
        search: term,
      } ).done( function( response ) {
        renderResults( response && response.success ? response.data.events : [], term );
      } ).fail( function( _, status ) {
        if ( status !== 'abort' ) {
          $results.empty().append(
              $( '<p class="ll-event-search-message"></p>' ).text( 'Sorry, the event search could not be loaded.' ),
          );
          $status.text( 'The event search could not be loaded' );
        }
      } );
    }

    function renderResults( events, term ) {
      $results.empty();

      if ( !events.length ) {
        $calendar.attr( 'hidden', true );
        $results.removeAttr( 'hidden' );
        $results.append(
            $( '<p class="ll-event-search-message"></p>' ).text( 'No events found for “' + term + '.”' ),
        );
        $status.text( 'No events found for ' + term );
        return;
      }

      const $heading = $( '<h3 class="ll-event-search-heading"></h3>' ).text(
          events.length + ( events.length === 1 ? ' event found' : ' events found' ),
      );
      const $list = $( '<ul class="ll-event-search-list"></ul>' );

      events.forEach( function( event ) {
        const $link = $( '<a></a>' ).attr( 'href', event.url ).text( event.title );
        const $item = $( '<li class="ll-event-search-item"></li>' ).append( $link );

        if ( event.date ) {
          $item.append( $( '<span></span>' ).text( event.date ) );
        }

        $list.append( $item );
      } );

      $results.append( $heading, $list );
      $status.text( $heading.text() + ' for ' + term );
    }

    function showCalendar() {
      $results.attr( 'hidden', true ).empty();
      $calendar.removeAttr( 'hidden' );
      $status.text( '' );
    }
  } );
} )( jQuery );
